import ConfigProvider from "./Provider";

export default function ConfigContainer({ children }) {
  return (
    <ConfigProvider>{children}</ConfigProvider>
  )
}
